var React = require('react');

function LoadingInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38 19.5C38 9.28273 29.7173 1 19.5 1C9.28273 1 1 9.28273 1 19.5C1 29.7173 9.28273 38 19.5 38C24.6499 38 29.3084 35.8957 32.6624 32.5","stroke":"white","strokeWidth":"2"}));
}

LoadingInline.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = LoadingInline;

LoadingInline.default = LoadingInline;
